export default __webpack_public_path__ + "img/kNaInmzP.3cb6ee75.svg";